import React, {useEffect, useState} from "react";
import './App.css'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FAQ from "./pages/FAQ";
import BoostLearn from "./components/BoostLearn";

function App() {

  const [faq, setFaq] = useState([])

  useEffect(()=>{
    const getFaQ = async ()=>{
      const data = await fetch('https://script.googleusercontent.com/macros/echo?user_content_key=dO3-Kjogo0juQkRd83VXz5QV5fQJ6rcJizUiWAL0b7vGS1E0dywl3XjFQl26bBmEl7lN4ip-Jt3ngkcNVDEa9ZTxhlqdFcRom5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnG2E5JKHSETmxpU5bGRgmkSIBT_luhZI4Qb0WFDBB_WzPP9n9Z3cZXJtuHEUjBIcjE_hFvAME6e4kMZOFQX8LKdHmfr2XeV08g&lib=MeFK5Qj7gnV4puUvTAOZ1pcKUfNXdiY_E').then(res => res.json()).catch(err => console.log(err))
      const updatedData = data.data.map(item => {
        return {
          category: item.category.replaceAll(" ", "_"),
          sub_category:item.sub_category.replaceAll(" ", "_") ,
          question:item.question ,
          answer:item.answer
        }
      })
      setFaq(updatedData)
    }

    getFaQ()
    
  },[])


  return (
    <div>

      <Navbar />
      <Router>
        <Routes>
          <Route path="/" element={<Home faqs={faq}/>} />
          <Route path="/:category" element={<Home faqs={faq}/>} />
          <Route path="/:category/:subCategory" element={<FAQ faqs={faq}/>} />
        </Routes>
      </Router>
      <BoostLearn />
      <Footer />
    </div>
  );
}

export default App;
